<template>
  <kst-table action paginated view-mode :data="dataList">
    <b-table-column centered sortable
      v-slot="{ column, row }"
      cell-class="ks-col-shortdatetime"
      field="CreatedDate"
      :label="Catalog.CreatedDate.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
      <template #header>
        <kst-header-blank />
      </template>
      <template #default="{ row }">
        <kst-tooltip info-mode>
          <template #content>
            <kst-list info-mode :items="Model.getResultInfo(row)"/>
          </template>
          <kst-icon info-mode/>
        </kst-tooltip>
      </template>
    </b-table-column>

    <b-table-column sortable
      v-slot="{ column, row }"
      cell-class="ks-col-number"
      field="TransactionNumber"
      :label="Catalog.TransactionNumber.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <template v-if="isAllWarehouse">
      <b-table-column sortable
        v-slot="{ column, row }"
        cell-class="ks-col-warehouse"
        field="TransWarehouseID"
        :label="RccdTransCatalog.TransWarehouseID.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="RccdTransCatalog"/>
      </b-table-column>
    </template>

    <b-table-column sortable
      v-slot="{ column, row }"
      field="InvoiceID"
      :label="RccdTransCatalog.InvoiceID.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RccdTransCatalog"/>
    </b-table-column>

    <b-table-column numeric sortable
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="InvoiceRecChanges"
      :label="RccdTransCatalog.InvoiceRecChanges.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RccdTransCatalog"/>
    </b-table-column>

    <b-table-column numeric sortable
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="InvoiceRecAfter"
      :label="RccdTransCatalog.InvoiceRecAfter.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RccdTransCatalog"/>
    </b-table-column>

    <b-table-column sortable
      v-slot="{ column, row }"
      field="ClientID"
      :label="RccdTransCatalog.ClientID.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RccdTransCatalog"/>
    </b-table-column>

    <b-table-column numeric sortable
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="ClientRecChanges"
      :label="RccdTransCatalog.ClientRecChanges.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RccdTransCatalog"/>
    </b-table-column>

    <b-table-column numeric sortable
      v-slot="{ column, row }"
      cell-class="ks-col-subtotal"
      field="ClientRecAfter"
      :label="RccdTransCatalog.ClientRecAfter.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="RccdTransCatalog"/>
    </b-table-column>

    <template #action="{ row }">
      <template v-if="row.HasAccess">
        <kst-actions fullLabel :actions="row.Actions"/>
      </template>
    </template>
  </kst-table>
</template>

<script>
import Catalog from "../RccdCatalog.js";
import Model from "../RccdModel.js";
import RccdTransCatalog from "../RccdTransCatalog.js";

export default {
  props: {
    searchData: Object,
    dataList: Array
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model,
    RccdTransCatalog: RccdTransCatalog,
    isAllWarehouse: false
  }),
  created() {
    this.init();
  },
  methods: {
    init() {
      this.isAllWarehouse =
        this.$kst.Search.getValue(this.searchData.WarehouseID, null) === null;
      Model.updateList(this.dataList);
    }
  }
}
</script>